import React from "react";
import { translate } from '../utils/useful'
import { languagesInfo, siteConfig, siteTheme } from '../variables/config'
// import i18n from "../i18n";
import TLink from "../components/TLink";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import { withRouter } from 'react-router-dom';
import i18n from "../i18n";


class Footer extends React.Component {

  state = {
    subscribed: false,
    email: '',
    socialNetworks: [
      { name: 'facebook', icon: 'https://image.flaticon.com/icons/svg/1409/1409943.svg' },
      { name: 'linkedin', icon: 'https://image.flaticon.com/icons/svg/1409/1409945.svg' },
      { name: 'instagram', icon: 'https://image.flaticon.com/icons/svg/2111/2111463.svg' },
      { name: 'youtube', icon: 'https://image.flaticon.com/icons/svg/2965/2965363.svg' },
      { name: 'aparat', icon: 'https://cdn.iconscout.com/icon/free/png-512/aparat-569197.png' },

    ],

    links:
    {
      company: [
        { title: translate('aboutus'), link: '/aboutus' },
        { title: translate('Tutorials'), link: '/tutorials' },
        { title: translate('services'), link: '/services' },

      ],

      fastAccess: [
        { title: translate('faq'), link: '/pages/faq' },
        { title: translate('payment-methods'), link: '/pages/payments' },
        { title: translate("privacy-policy"), link: '/pages/policy' },
      ],


      agreements: [
        { title: translate("privacy-policy"), link: '/pages/policy' },
        { title: translate("terms"), link: '/pages/terms' },
      ],



    }


  }


  // subscribe() {
  //   localStorage.setItem('subscribed', this.state.email)
  //   this.setState({ subscribed: true })
  // }

  render() {
    return (
      <footer
        className={"w-100 "}
        style={{ bottom: 0, position: 'relative' }}
      >
        <div className={'mb-2'} style={{ color: 'rgba(10,12,15,1)', backgroundColor: '#fff', margin: 0, paddingBottom: 20 }}>


          <div className={'container'}>
            <div className="d-md-flex d-block w-100 pt-4" style={{ justifyContent: "space-between" }}>

              {/* <div className={'col-6 col-sm-6 col-md-4 mt-4'}>
                <div className="mb-2" style={{ fontSize: 17, fontWeight: 'bold', color: '#202020' }}>{translate("fast-access")}</div>
                {this.state.links.company.map((prop, index) => {
                  return (
                    <div key={index} style={{ display: 'block-inline' }}>
                      <TLink to={prop.link}>
                        <span style={{ fontSize: 15, marginTop: 5 }}>{prop.title}</span>
                      </TLink>
                    </div>
                  )
                })}
              </div>


              <div className={'col-6 col-sm-6 col-md-4 mt-4'}>
                <div className="mb-2" style={{ fontSize: 17, fontWeight: 'bold', color: '#202020' }}>{translate("customer-service")}</div>
                {this.state.links.fastAccess.map((prop, index) => {
                  return (
                    <div key={index} style={{ display: 'block-inline' }}>
                      <TLink to={prop.link}>
                        <span style={{ fontSize: 15, marginTop: 5 }}>{prop.title}</span>
                      </TLink>
                    </div>
                  )
                })}
              </div>



              <div className={'col-6 col-md-4 mt-4'}>
                <div className={"mb-2"} style={{ fontSize: 17, fontWeight: 'bold', color: '#202020' }}>{translate('contactus')}</div>

                <div className="mt-3 mb-3 d-flex d-block  align-items-center  "  >

                  <img className="" src="https://image.flaticon.com/icons/svg/1034/1034131.svg" width="20px" alt="" />
                  <div className="mld-2 mt-2 mt-lg-0">
                    <a href={"tell:" + siteConfig.phone} style={{ fontSize: 15 }}>{siteConfig.phone}</a>
                  </div>
                </div>

                <div className="mt-2 mb-3 d-flex d-block  align-items-center mt-md-0  "  >
                  <img className="" src="https://image.flaticon.com/icons/svg/1034/1034146.svg" width="20px" alt="" />
                  <div className="mld-2 mt-2 mt-lg-0">
                    <a href={"mailto:" + siteConfig.email} style={{ fontSize: 15 }}>{siteConfig.email}</a>
                    
                  </div>
                </div>


              </div> */}


              {/* <div className={'col-12  p-0'}>
                <hr style={{ borderTop: "1px solid #bcd", opacity: 1 }}></hr>
              </div> */}


              <div className={''}>
                <span className='' style={{ whiteSpace: 'pre-wrap', fontSize: 14, }}>{i18n.language === "fa" ? siteConfig.addressFa : siteConfig.addressEn}</span>
                <span className='flexc ' style={{ whiteSpace: 'pre-wrap', fontSize: 14, }}>&copy; {translate('copyright', { name: siteConfig.name })}</span>

              </div>
              {/* <div className={''}>
                {siteConfig.showLanguage && (
                  <div className="flexc mt-2 mt-md-0 d-flex" style={{ justifyContent: "end" }}>
                    {languagesInfo[this.props.settings.language] && (
                      <div className=" " style={{ position: 'relative', }}>
                        <button onClick={() => this.toggleLanguagesBox()} className="flexcc language-but p-0">
                          <img className="" src={languagesInfo[this.props.settings.language].icon} height="20px" alt="" />
                          <span className=" mld-2" style={{}}>{languagesInfo[this.props.settings.language].name}</span>
                        </button>
                        {this.state.showLanguagesBox && (
                          <div ref={el => this.language_select_box = el} className="blur-back language-select-box fadein">
                            {Object.values(languagesInfo).map((prop, index) => {
                              return (
                                <button key={index} className={" flexc language-select-option " + (index !== 0 ? "mt-3" : '')} onClick={() => this.changeLanguage('language', prop.shortName)}>
                                  <img className="mrd-2" src={prop.icon} alt={"language-" + prop.name} />
                                  <div>{prop.name}</div>
                                </button>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div> */}

              {/* <div className={'col-6 col-md-4 text-right'}>
                <div className="d-flex mb-1 justify-content-start justify-content-md-end">
                  {this.state.links.agreements.map((prop, index) => {
                    return (
                      <div key={index} className="mld-2 flexcc">
                        <TLink to={prop.link}>
                          <span style={{ fontSize: 15, marginTop: 5 }}>{prop.title}</span>
                        </TLink>
                        {index == 0 && (
                          <p className="mx-2 my-0 opacity-7">|</p>
                        )}
                      </div>
                    )
                  })}
                </div>


              </div> */}




              {/* <div className={'col-12 col-md-6 '}>
                <div className=" d-flex justify-content-start justify-content-md-end" style={{ filter: 'grayscale(0%) contrast(100%)' }}>


                  {this.state.socialNetworks.map((prop, index) => {
                    if (siteConfig[prop.name] && siteConfig[prop.name] != '')
                      return (
                        <a key={index} rel="no-follow noopener noreferrer" target="_blank" className="mld-2" href={siteConfig[prop.name]}>
                          <img src={prop.icon} width="20px" alt="" />
                        </a>
                      )
                  })}


                </div>
              </div> */}


            </div>




          </div>


        </div>
      </footer>
    );
  }


  changeLanguage = (key, value) => {
    i18n.changeLanguage(value)
    this.closeBox()
  }

  toggleLanguagesBox() {
    if (!this.state.showLanguagesBox) {
      document.addEventListener('mousedown', this.closeBox);
      this.setState({ showLanguagesBox: true })
    } else {
      this.closeBox()
    }
  }

  closeBox = (event) => {
    if (!event || (this.language_select_box && !this.language_select_box.contains(event.target))) {
      document.removeEventListener('mousedown', this.closeBox);
      let box = document.querySelectorAll('.language-select-box')
      if (box) {
        box[0].classList.add('fadeout')
      }

      setTimeout(() => {
        this.setState({ showLanguagesBox: false })
      }, 400);
    }
  }

}



const mapStateToProps = state => ({ settings: state.settings, cart: state.cart, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Footer));
